import { ADMIN_ROLES_LIST_ACTIONS } from "../../actionType/adminRoles";

const intialState = {
  adminRolesList: [],
  isAdminRolesListLoader: false,
};

export const adminRolesReducer = (state = intialState, { type, payload }: any) => {
  switch (type) {
    case ADMIN_ROLES_LIST_ACTIONS.ADMIN_ROLES_LIST_REQUEST:
      return {
        ...state,
        adminRolesList: payload,
        isAdminRolesListLoader: true,
      };
    case ADMIN_ROLES_LIST_ACTIONS.ADMIN_ROLES_LIST_RESPONSE:
      return {
        ...state,
        adminRolesList: payload,
        isAdminRolesListLoader: false,
      };

    case ADMIN_ROLES_LIST_ACTIONS.ADMIN_ROLES_LIST_ERROR:
      return {
        ...state,
        adminRolesList: payload,
        isAdminRolesListLoader: false,
      };
    default:
      return state;
  }
};
